import React from 'react'

export const HomePage = () => {
  return (
    <div>Hola Mundo</div>
  )
}
